import { TAvailableConfigValues } from '@customTypes/common';

export interface IPlaybackStateControllerConfig {
  autoPlay: boolean;
  syncToLiveEdge: boolean;
  syncToLiveDelta: number;
  playingTimeFractionCollectionWindow: number;
  stallDurationToDisableTargetBufferDecrease: number;
}

export const defaultPlaybackStateControllerConfig: IPlaybackStateControllerConfig = {
  autoPlay: false,
  syncToLiveEdge: false,
  syncToLiveDelta: 1,
  playingTimeFractionCollectionWindow: 100000,
  stallDurationToDisableTargetBufferDecrease: 10000,
};

export const availablePlaybackStateControllerConfig: TAvailableConfigValues<IPlaybackStateControllerConfig> = {};
